import { LlmComponent, LlmInstance, LlmProvider } from '@websolutespa/bom-mixer-llm';
import { useRef } from 'react';
import { mock } from './mock';
import { llmPlugin } from './plugin';

export function Llm() {
  const llmRef = useRef<LlmInstance>(null);
  return (
    <LlmProvider
      appKey="app-test"
      apiKey="b2c5912a-7b26-4c0c-8fd4-d046182c037c"
      plugins={[
        llmPlugin,
      ]}
      test={mock}
      defaultTheme={{}}
      contexts={[{
        title: 'Architetto',
        context: {
          tone: 'architect',
        },
      }, {
        title: 'Venditore di mobili',
        context: {
          tone: 'dealer',
        },
      }, {
        title: 'Consumatore',
        context: {
          tone: 'consumer',
        },
      }]}
    >
      <LlmComponent ref={llmRef} />
    </LlmProvider>
  );
}
